import { store } from "store/store"
import { isLocalAdminAuthBypassEnabled } from "@/config/typedEnv"
export {
  resolveServiceEndpoint,
  validatePlatformServiceEndpoints,
} from "./platformServiceEndpoints"

type ClerkWindow = Window & {
  Clerk?: {
    session?: {
      getToken: (params: { skipCache?: boolean; template: string }) => Promise<string | null>
    }
  }
}

// forceFresh mints a brand-new token (bypassing Clerk's ~60s cache). Needed by
// the login provisioning poll: API Gateway caches the admin authorizer's Deny
// verdict keyed on the token, so reusing one cached token would keep hitting the
// cached Deny for the whole poll. A fresh token per attempt is a new cache key,
// re-invoking the authorizer as soon as the merchant binding lands.
export const getClerkAppsyncToken = async (options?: { forceFresh?: boolean }) => {
  try {
    const clerk = (window as ClerkWindow).Clerk
    if (!clerk?.session?.getToken) return null

    return await clerk.session.getToken({
      template: "appsync",
      ...(options?.forceFresh ? { skipCache: true } : {}),
    })
  } catch {
    return null
  }
}

export const getClerkBearerToken = async (
  serviceName: string,
  options?: { forceFresh?: boolean }
) => {
  const token = await getClerkAppsyncToken(options)
  if (!token && isLocalAdminAuthBypassEnabled) return "local-dev-token"
  if (!token) throw new Error(`Unable to resolve Clerk token for ${serviceName}`)
  return token
}

export const getPlatformHeaders = async (
  contentType?: string,
  options?: { forceFresh?: boolean }
) => {
  const token = await getClerkBearerToken("platform request", options)
  const merchantId = store.getState().user.userInfo.merchantId.trim()
  const headers: Record<string, string> = {
    Authorization: `Bearer ${token}`,
  }

  if (contentType) headers["Content-Type"] = contentType
  if (merchantId) headers["X-Tint-Merchant-Id"] = merchantId

  return headers
}
